<template>
  <div id="footer" class="container-fluid">
    <div style="display: flex; flex-direction: column; align-items: center;">
      <img style="width: 120px; margin: 20px 0;" src="@/assets/img/erweima.jpg" alt="微信公众号">微信公众号
    </div>
    <p class="address_tel_fax">
      <span>山东省临沂市兰山区临西十三路与大山路交汇处北800米路东（兰山区聚才二路0007号）</span>
      <span>Tel：15315080063</span>
    </p>
    <p class="copy"> &copy; 2018 - {{ new Date().getFullYear() }} 弘达亚飞汽车贸易有限公司</p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue